/*
 * Copyright (C) 2024 Das Land Schleswig-Holstein vertreten durch den
 * Ministerpräsidenten des Landes Schleswig-Holstein
 * Staatskanzlei
 * Abteilung Digitalisierung und zentrales IT-Management der Landesregierung
 *
 * Lizenziert unter der EUPL, Version 1.2 oder - sobald
 * diese von der Europäischen Kommission genehmigt wurden -
 * Folgeversionen der EUPL ("Lizenz");
 * Sie dürfen dieses Werk ausschließlich gemäß
 * dieser Lizenz nutzen.
 * Eine Kopie der Lizenz finden Sie hier:
 *
 * https://joinup.ec.europa.eu/collection/eupl/eupl-text-eupl-12
 *
 * Sofern nicht durch anwendbare Rechtsvorschriften
 * gefordert oder in schriftlicher Form vereinbart, wird
 * die unter der Lizenz verbreitete Software "so wie sie
 * ist", OHNE JEGLICHE GEWÄHRLEISTUNG ODER BEDINGUNGEN -
 * ausdrücklich oder stillschweigend - verbreitet.
 * Die sprachspezifischen Genehmigungen und Beschränkungen
 * unter der Lizenz sind dem Lizenztext zu entnehmen.
 */
export enum PathParam {
  AUSWERTUNG_ID = 'auswertungId',
  DATEN_ANFRAGE_ID = 'datenanfrageId',
  DATEN_FREIGABE_ID = 'datenFreigabeId',
  PROCESSOR_ID = 'processorId',
  PROCESSOR_ASSIGNMENT_ID = 'processorAssignmentId',
  VORLAGEN_SYSTEM_ID = 'vorlagenSystemId',
  VORLAGE_ID = 'vorlageId',
  ZUGANGPUNKT_ID = 'zugangpunktId',
  ONLINE_DIENST_ID = 'onlineDienstId',
  ANTRAGSTELLER_NOTIFICATION_ID = 'antragstellerNotificationId',
  USER_NOTIFICATION_ID = 'userNotificationId',
}

export enum Routes {
  PROFILE = 'mein-profil',
  POSTFACH = 'postfach',
  BENUTZER = 'benutzer',
  BENUTZER_NEU = 'benutzer/neu',
  BENUTZER_ID = 'benutzer/:userid',
  ORGANISATIONSEINHEITEN = 'organisationseinheiten',
  LOESCH_ORGANISATION_EINHEIT = 'loesch-organisationseinheit',
  NOT_FOUND = 'not-found',
  AUSWERTUNGEN = 'statistik/auswertungen',
  AUSWERTUNGEN_NEU = 'statistik/auswertungen/neu',
  AUSWERTUNGEN_ID = `statistik/auswertungen/:${PathParam.AUSWERTUNG_ID}`,
  DATENFREIGABEN = 'statistik/datenfreigaben',
  DATENFREIGABEN_ID = `statistik/datenfreigaben/:${PathParam.DATEN_FREIGABE_ID}`,
  DATENANFRAGEN = 'statistik/datenanfragen',
  DATENANFRAGEN_NEU = 'statistik/datenanfragen/neu',
  DATENANFRAGEN_ID = `statistik/datenanfragen/:${PathParam.DATEN_ANFRAGE_ID}`,
  DATENANFRAGEN_ID_VEROEFFENTLICHEN = `statistik/datenanfragen/:${PathParam.DATEN_ANFRAGE_ID}/veroeffentlichen`,
  PROCESSOR = `schnittstellen/prozessoren`,
  PROCESSOR_NEU = `schnittstellen/prozessoren/neu`,
  PROCESSOR_ID = `schnittstellen/prozessoren/:${PathParam.PROCESSOR_ID}`,
  PROCESSOR_ASSIGNMENT_NEU = `schnittstellen/prozessoren/:${PathParam.PROCESSOR_ID}/zuweisung/neu`,
  PROCESSOR_ASSIGNMENT_ID = `schnittstellen/prozessoren/:${PathParam.PROCESSOR_ID}/zuweisung/:${PathParam.PROCESSOR_ASSIGNMENT_ID}`,
  VORLAGEN_SYSTEME = `schnittstellen/vorlagensysteme`,
  VORLAGEN_SYSTEME_NEU = `schnittstellen/vorlagensysteme/neu`,
  VORLAGEN_SYSTEME_ID = `schnittstellen/vorlagensysteme/:${PathParam.VORLAGEN_SYSTEM_ID}`,
  VORLAGE_NEU = `schnittstellen/vorlagensysteme/:${PathParam.VORLAGEN_SYSTEM_ID}/vorlage/neu`,
  VORLAGE_ID = `schnittstellen/vorlagensysteme/:${PathParam.VORLAGEN_SYSTEM_ID}/vorlage/:${PathParam.VORLAGE_ID}`,
  ZUGANGPUNKTE = 'zugangspunkte',
  ZUGANGPUNKTE_NEU = 'zugangspunkte/neu',
  ZUGANGPUNKTE_ID = `zugangspunkte/:${PathParam.ZUGANGPUNKT_ID}`,
  ONLINE_DIENST = 'online-dienste',
  ANTRAGSTELLER_NOTIFICATIONS = 'antragsteller-notifications',
  ANTRAGSTELLER_NOTIFICATIONS_NEU = 'antragsteller-notifications/neu',
  ANTRAGSTELLER_NOTIFICATIONS_ID = `antragsteller-notifications/:${PathParam.ANTRAGSTELLER_NOTIFICATION_ID}`,
  USER_NOTIFICATIONS = 'benachrichtigungen',
  USER_NOTIFICATIONS_NEU = 'benachrichtigungen/neu',
  USER_NOTIFICATIONS_ID = `benachrichtigungen/:${PathParam.USER_NOTIFICATION_ID}`,
}
